
import { Link, useParams } from 'react-router-dom';
import { getWorkerRatings } from '../../workers/Workers';
import axios from "axios";
import { useEffect, useState } from "react";
import MainLayout from "src/components/MainLayout";
import { AppConfig } from "src/config/AppConfig";
import { useAppDispatch, useAppSelector } from "src/hooks/redux/hooks";
import "../../workers/WorkerCategories.css"
import Swal from "sweetalert2";
import eye from "../../../../assets/img/icons/eye-solid.svg"
import profileIcon from "../../../../assets/img/icons/vecteezy_man-empty-avatar-vector-photo-placeholder-for-social_36594092.jpg"
import "../../workers/Workers.css";
import LoadingGif from "src/components/layout/Loader";
import { startLoading, stopLoading } from "src/store/loading/loadingSlice";
import { ECategory, ITransactions, IWorker, IWorkerRatings } from "src/helper/interfaces";
import Cookies from "js-cookie";
import placeholderImg from "../../../../assets/img/landscape-placeholder-svgrepo-com.svg";
import { formatCategory, formatDiffrentDate } from "src/utils/normalFuntions";
import Paginator from "src/components/layout/Paginator";
import phoneIcon from "../../../../assets/img/icons/phone-svgrepo-com.svg";
import idCard from "../../../../assets/img/icons/id-card-svgrepo-com.svg";
import copyIcon from "../../../../assets/img/icons/copy-svgrepo-com.svg";
import permanentAddress from "../../../../assets/img/icons/address-permanent.svg";
import currentAddress from "../../../../assets/img/icons/address-current.svg";
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable';
import bill from "../../../../assets/img/icons/marketing-bill-payment-invoice-receipt-svgrepo-com.svg";
import copy from "copy-to-clipboard";
import { toast, Bounce, } from 'react-toastify';
import LightGallery from 'lightgallery/react';
import lgZoom from 'lightgallery/plugins/zoom';
import lgShare from 'lightgallery/plugins/share';
import lgHash from 'lightgallery/plugins/hash';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import { IWorkerEarnings } from "src/helper/interfaces";
import ExportDocs from "src/components/layout/ExportDocs";
import StarRating from "src/components/layout/StarRating"
import { getAllTransactions } from '../../transactions/Transaction';


export type sidePages = {
   workerDetails: boolean,
   transactions: boolean,
   earnings: boolean,
   leads: boolean,
   ratings: boolean
}
const getWorkerById = async (token: string, id: string) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/worker/${id}`, {
      headers: {
         "x-access-token": token
      }
   });
}
const getWorkerEarnings = async (token: string, id: string, filterBy: string, pageNo: number, pageSize: number) => {
   return await axios.get(`${AppConfig?.DEV_SERVER}/worker-earnings/${id}`, {
      headers: {
         "x-access-token": token
      },
      params: {
         filterReferralsBy: filterBy,
         page: pageNo,
         pageSize
      }
   })
}


function WorkerDetailsPage() {

   const dispatch = useAppDispatch();
   const { id } = useParams();
   const Token = Cookies.get("token");
   const [transactions, setTransactions] = useState<ITransactions[]>([]);
   const [earningsArray, setEarningsArray] = useState<IWorkerEarnings[]>([]);
   const [ratingsArray, setRatingsArray] = useState<IWorkerRatings[]>([]);
   const [averageRating, setAverageRating] = useState(0);
   const [selectedWorker, setSelectedWorker] = useState<IWorker | null>(null);
   const loading = useAppSelector(state => state.loading.value);
   const [totalData, setTotalData] = useState({
      totalEarnings: 0,
      totalLeads: 0
   });

   const [clickedSidePage, setClickedSidePage] = useState<sidePages>({
      workerDetails: true,
      transactions: false,
      earnings: false,
      leads: false,
      ratings: false
   });
   const [PaginatedData, setPaginatedData] = useState({
      pageNo: 1,
      pageSize: 10,
      totalPages: 0
   });

   const setHandlePageClick = (page: keyof sidePages) => {
      setClickedSidePage({
         workerDetails: page === "workerDetails",
         transactions: page === "transactions",
         earnings: page === "earnings",
         leads: page === "leads",
         ratings: page === "ratings"
      })
   };

   useEffect(() => {
      // console.log("id: ", id)
      getWorkerById(Token as string, id as string).then((res) => {

         if (res?.data?.status_code === 200) {
            setSelectedWorker(res?.data?.data);
         }

      }).catch((err: any) => {
         console.log(err)
      })
   }, [id]);


   useEffect(() => {
      if (Token) {
         if (clickedSidePage?.transactions) {
            getAllTransactions(Token, "all", "worker", id as string, PaginatedData?.pageNo, "", PaginatedData?.pageSize).then((res) => {

               if (res?.data?.status_code === 200) {

                  setTransactions(res?.data?.data?.data);
                  setPaginatedData({
                     ...PaginatedData,
                     totalPages: res?.data?.data?.totalPages
                  })
               }
            })
               .catch((err: any) => {
                  console.log(err)
               })
         }
         else if (clickedSidePage?.ratings) {
            const params = {
               token: Token,
               id: id as string,
               pageNo: PaginatedData?.pageNo,
               pageSize: PaginatedData?.pageSize,
               type: "worker",
            };
            getWorkerRatings(params).then((res) => {

               if (res?.data?.status_code === 200) {

                  setRatingsArray(res?.data?.data?.results);
                  setPaginatedData({
                     ...PaginatedData,
                     totalPages: res?.data?.data?.totalPages
                  });
                  setAverageRating(res?.data?.data?.averageRating);
               }
            })
               .catch((err: any) => {
                  console.log(err)
               })
         }
         else if (clickedSidePage?.leads || clickedSidePage?.earnings) {
            getWorkerEarnings(Token, id as string, "both", PaginatedData?.pageNo, PaginatedData?.pageSize).then((res) => {

               if (res?.data?.status_code === 200) {
                  const data = res?.data?.data;
                  setEarningsArray(data?.data);
                  setPaginatedData({
                     ...PaginatedData,
                     totalPages: res?.data?.data?.totalPages
                  });

                  setTotalData({
                     ...totalData,
                     totalEarnings: data?.totalEarnigs,
                     totalLeads: data?.totalDocs
                  })
               }
            })
               .catch((err: any) => {
                  console.log(err)
               })
         }
      }

   }, [PaginatedData?.pageNo, PaginatedData?.pageSize, clickedSidePage]);


   const copyToClipboard = (type: string) => {
      if (type === "pan") {
         copy(selectedWorker?.document_details?.pan_number ?? "");
      }
      else if (type === "aadhaar") {
         copy(selectedWorker?.document_details?.adhaar_number ?? "");
      }
      else {
         copy(selectedWorker?.document_details?.firm_gst_number ?? "")
      }
      // alert(`You have copied "${selectedWorker?.pan_number ?? ""}"`);
      toast.success('Copied to clipboard!', {
         position: 'top-right',
         autoClose: 1300,
         transition: Bounce
      });
   };


   const handleInvoiceClick = async (id: string, order_type: string) => {

      if (!id) return;
      dispatch(startLoading());
      try {
         const res = await axios.get(`${AppConfig.DEV_SERVER}/invoice/${id}`, {
            headers: {
               "x-access-token": Token,
            },
            params: {
               type: order_type,
            },
         });

         if (res?.data?.status_code === 200) {
            dispatch(stopLoading());
            const pdfUrl = res?.data?.data?.file;
            // setPdf(pdfUrl);
            window.open(pdfUrl, "_blank"); // Open the PDF in a new tab
         } else {
            dispatch(stopLoading());
            Swal.fire({
               icon: "error",
               title: "Something Went Wrong...",
               text: `${res?.data?.msg}`,
            });
         }
      } catch (error) {
         dispatch(stopLoading());
         Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to fetch the invoice.",
         });
      }
   };

   useEffect(() => {
      console.log(selectedWorker);
   }, [selectedWorker]);

   const handlePageSizeChange = (e: any) => {
      setPaginatedData({
         ...PaginatedData,
         pageSize: e.target.value
      })
   };
   const convertedDate = formatDiffrentDate(selectedWorker?.createdAt as string);

   // formattedData for Transactions
   const formattedDataForTransaction = transactions.map((item, i) => {
      const date = formatDiffrentDate(item?.createdAt);

      return {
         _id: item?._id,
         order_name: item?.order_name,
         order_type: item?.order_type,
         unique_id: item?.unique_id,
         payment_amount: item?.payment_amount,
         status: item?.status ? "Success" : "Failed",
         createdAt: date?.formattedDate,
      };
   });

   // formattedData for Earnings
   const formattedDataForEarnings = earningsArray.map((item, i) => {
      const date = formatDiffrentDate(item?.createdAt);

      return {
         _id: item?._id,
         service_title: item?.service_title,
         service_count: item?.service_count,
         user_name: item?.User?.name,
         user_phone_or_email: item?.User?.phone || item?.User?.email,
         service_charges: item?.service_charges,
         createdAt: date?.formattedDate,
         // Conditionally add values for SALES_PROFESSIONAL workers
         worker_id: selectedWorker?.worker_type === ECategory?.SALES_PROFESSIONAL ? item?.worker_id : undefined,
         membership_or_service_type: selectedWorker?.worker_type === ECategory?.SALES_PROFESSIONAL
            ? formatCategory(item?.membership_type && "Membership" || item?.service_type)
            : undefined,
         worker_name: selectedWorker?.worker_type === ECategory?.SALES_PROFESSIONAL ? item?.Worker?.name ?? "NA" : undefined,
         worker_phone: selectedWorker?.worker_type === ECategory?.SALES_PROFESSIONAL ? item?.Worker?.phone ?? "NA" : undefined,
         commision: selectedWorker?.worker_type === ECategory?.SALES_PROFESSIONAL ? item?.commision : undefined,
         is_lead_matured: selectedWorker?.worker_type === ECategory?.SALES_PROFESSIONAL ? (item?.is_lead_matured ? "Yes" : "No") : undefined
      };
   });


   //formattedData for New leads
   const formattedDataForLeads = earningsArray?.map((data, i) => {
      const createdAt = formatDiffrentDate(data?.createdAt);
      return {
         worker_id: data?.worker_id,
         name: data?.Worker?.name,
         worker_type: formatCategory(data?.Worker?.worker_type),
         phone: data?.Worker?.phone,
         service: data?.membership_type ? "Membership" : data?.service_type ? "Subscription" : "",
         subscription_type: formatCategory(data?.subscription_type) ?? "NA",
         joined_at: createdAt?.formattedDate,

      };
   });

   // headers for New leads 
   const headersForLeads = [

      { label: "Worker Name", key: "name" },
      { label: "Worker Type", key: "worker_type" },
      { label: "Phone", key: "phone" },
      { label: "Service", key: "service" },
      { label: "Subscription Type", key: "subscription_type" },
      { label: "Joined At", key: "joined_at" },

   ];

   // heards for Transactions
   const headersForTransaction = [
      // Corresponds to the row number
      { label: "Order ID", key: "_id" },
      { label: "Order Name", key: "order_name" },
      { label: "Order Type", key: "order_type" },
      { label: "Transaction ID", key: "unique_id" },
      { label: "Amount", key: "payment_amount" },
      { label: "Status", key: "status" },
      { label: "Date", key: "createdAt" },
   ];

   // heards for Earnings
   const headersFOrEarnings = selectedWorker?.worker_type === ECategory?.SALES_PROFESSIONAL ? [

      { label: "Worker ID", key: "worker_id" },
      { label: "Membership / Service Type", key: "membership_or_service_type" },
      { label: "Worker Name", key: "worker_name" },
      { label: "Worker Phone", key: "worker_phone" },
      { label: "Commission", key: "commision" },
      { label: "Lead Matured", key: "is_lead_matured" },
      { label: "Created At", key: "createdAt" }
   ] : [

      { label: "Service Name", key: "service_title" },
      { label: "Service Count", key: "service_count" },
      { label: "User Name", key: "user_name" },
      { label: "Phone / Email", key: "user_phone_or_email" },
      { label: "Earnings", key: "service_charges" },
      { label: "Worked At", key: "createdAt" }
   ];

   //export pdf for transaction
   const exportPdfForTransaction = () => {
      const doc = new jsPDF();
      doc.text("Worker Transactions", 14, 10);

      // Define the columns for the table
      const tableColumns = [
         "Sr.No.",
         "Order Name",
         "Order Type",
         "Transaction ID",
         "Amount",
         "Status",
         "Date",
      ];


      const tableData = formattedDataForTransaction.map((item, i) => {
         const rowNumber = (PaginatedData?.pageNo - 1) * PaginatedData?.pageSize + (i + 1);
         return [
            rowNumber,
            item.order_name || '',
            item.order_type || '',
            item.unique_id || '',
            item.payment_amount || 0,
            item.status || '',
            item.createdAt || '',
         ]
      });

      // Use autoTable to generate the table
      autoTable(doc, {
         head: [tableColumns],
         body: tableData,
      });
      // Save the generated PDF
      doc.save('worker_transactions.pdf');
   };

   //export pdf for transaction
   const exportPdfForEarnings = () => {
      const doc = new jsPDF();
      doc.text("Workers Earnigs", 14, 10);
      // Define the columns for the table
      let tableColumns: any[] = [];
      // const serviceType = ?.membership_type ? "Memberhsip" : ?.service_type ? "Subscription" : ""
      if (selectedWorker?.worker_type === ECategory?.SALES_PROFESSIONAL) {
         tableColumns = ["Worker ID", "Membership / Service Type", "Worker Name", "Worker Phone", "Commission", "Lead Matured", "Created At"
         ]
      } else {
         tableColumns = ["Service Name", "Service Count", "User Name", "Phone / Email", "Earnings", "Worked At"]

      }

      const tableData = formattedDataForEarnings.map((item, i) => {
         const rowNumber = (PaginatedData?.pageNo - 1) * PaginatedData?.pageSize + (i + 1);
         return selectedWorker?.worker_type === ECategory?.SALES_PROFESSIONAL ? [

            // Conditionally add values for SALES_PROFESSIONAL workers
            rowNumber,
            item?.worker_id || "",
            item?.membership_or_service_type || "",
            item?.worker_name || "",
            item?.worker_phone || "",
            item?.commision || "",
            item?.is_lead_matured || "",
            item?.createdAt || "",

         ] : [
            rowNumber,
            item?._id || "",
            item?.service_title || "",
            item?.service_count || "",
            item?.user_name || "",
            item?.user_phone_or_email || "",
            item?.service_charges || "",
            item?.createdAt || "",
         ]
      });

      // Use autoTable to generate the table
      autoTable(doc, {
         head: [tableColumns],
         body: tableData,
      });
      // Save the generated PDF
      doc.save('worker_earnings.pdf');
   };


   const exportPdfForLeads = () => {

      const doc = new jsPDF();
      doc.text("Worker Leads", 14, 10);

      // Define the columns for the table
      const tableColumns = [
         "Sr.No.",
         "Worker Name",
         "Worker Type",
         "Phone",
         "Service",
         "Subscription Type",
         "Joined At"

      ];

      const tableData = formattedDataForLeads.map((item, i) => {
         const rowNumber = (PaginatedData?.pageNo - 1) * PaginatedData?.pageSize + (i + 1);
         return [
            rowNumber,
            item?.name,
            item?.worker_type,
            item?.phone,
            item?.service,
            item?.subscription_type,
            item?.joined_at
         ]
      });

      // Use autoTable to generate the table
      autoTable(doc, {
         head: [tableColumns],
         body: tableData,
      });
      // Save the generated PDF
      doc.save('worker_leads.pdf');
   };

   return (
      <MainLayout showAllFilters={true}>
         <div className=" main-div">

            <div className={`category-main me-2 p-3 p-md-4 `} style={{ background: "transparent" }}>

               <div className="row">

                  <div className="col-xxl-3 col-xl-4 p-2 theiaStickySidebar">
                     <div className="theiaStickySidebar"
                        style={{ paddingTop: " 0px", paddingBottom: "1px", position: "static", transform: 'none', top: "0px", left: "276px" }}>
                        <div className="card border-white ">
                           <div className="card-header border-1 " style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                              <div className="d-flex align-items-center flex-wrap row-gap-3">
                                 <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                                    <img
                                       src={
                                          selectedWorker?.profile_pic
                                             ? typeof selectedWorker?.profile_pic === 'string'
                                                ? selectedWorker?.profile_pic
                                                : URL.createObjectURL(selectedWorker?.profile_pic)
                                             : profileIcon
                                       }

                                    />
                                 </div>
                                 <div className="d-flex flex-column">
                                    <h5 className="mb-1 text-start">{selectedWorker?.name ?? "NA"} </h5>
                                    <span className="text-start mb-1">{selectedWorker?.phone ?? "NA"}</span>
                                    <span className="text-start">Joined: {convertedDate?.formattedDate ?? "NA"} </span>
                                 </div>
                              </div>
                           </div>
                           <div className="card-body text-start">
                              <h5 className="mb-3">Basic Information</h5>
                              <dl className="row mb-0">
                                 {/* Worker Type */}
                                 <dt className="col-5 col-md-4 fw-medium text-dark mb-3"> Id</dt>
                                 <dd className="col-7 col-md-8 mb-3">{selectedWorker?._id ?? "NA"}</dd>
                                 <dt className="col-5 col-md-4 fw-medium text-dark mb-3"> Dial Code</dt>
                                 <dd className="col-7 col-md-8 mb-3">{selectedWorker?.dial_code ?? "NA"}</dd>
                                 <dt className="col-5 col-md-4 fw-medium text-dark mb-3">Gender</dt>
                                 <dd className="col-7 col-md-8 mb-3">{selectedWorker?.gender ?? "NA"}</dd>

                                 <dt className="col-5 col-md-4 fw-medium text-dark mb-3">Otp</dt>
                                 <dd className="col-7 col-md-8 mb-3">{selectedWorker?.otp ?? "NA"}</dd>

                                 <dt className="col-5 col-md-4 fw-medium text-dark mb-3">Worker Type</dt>
                                 <dd className="col-7 col-md-8 mb-3">{formatCategory(selectedWorker?.worker_type as string) ?? "NA"}</dd>

                                 {/* You Are */}
                                 {
                                    selectedWorker?.worker_type === ECategory?.SELLER ?
                                       <>
                                          <dt className="col-5 col-md-4 fw-medium text-dark mb-3">Type of Business</dt>
                                          <dd className="col-7 col-md-8 mb-3">{selectedWorker?.type_of_business ?? "NA"}</dd>
                                          <dt className="col-5 col-md-4 fw-medium text-dark mb-3">You are a</dt>
                                          <dd className="col-7 col-md-8 mb-3">{selectedWorker?.you_are_a ?? "NA"}</dd>
                                       </> : ""
                                 }

                                 {/* Sub Type */}
                                 {(selectedWorker?.worker_type !== "worker_professional" && selectedWorker?.worker_type !== ECategory?.SELLER) && (
                                    <>
                                       <dt className="col-5 col-md-4 fw-medium text-dark mb-3">Sub Type</dt>
                                       <dd className="col-7 col-md-8 mb-3">{selectedWorker?.sub_worker_type?.join(", ") ?? "NA"}</dd>
                                    </>
                                 )}


                                 {/* Specifications */}
                                 {selectedWorker?.worker_type !== "sales_professional" && (
                                    <>
                                       <dt className="col-5 col-md-4 fw-medium text-dark mb-3">Specifications</dt>
                                       <dd className="col-7 col-md-8 mb-3">
                                          {selectedWorker?.worker_type === "business_firm"
                                             ? selectedWorker?.document_details?.worker_specialization?.join(", ") ?? "NA"
                                             : selectedWorker?.specification?.join(", ") ?? "NA"}
                                       </dd>
                                    </>
                                 )}
                                 {
                                    selectedWorker?.worker_type === ECategory?.SALES_PROFESSIONAL ?
                                       <>
                                          <dt className="col-5 col-md-4 fw-medium text-dark mb-3">My Refferral</dt>
                                          <dd className="col-7 col-md-8 mb-3">
                                             {selectedWorker?.my_referral ?? "NA"}

                                          </dd>
                                       </> : ''

                                 }
                                 <dt className="col-5 col-md-4 fw-medium text-dark mb-3">Wallet Amount</dt>
                                 <dd className="col-7 col-md-8 mb-3">&#8377; {selectedWorker?.walletAmount?.toFixed(2) ?? 0}</dd>

                              </dl>

                           </div>
                        </div>
                        <div className="card border-white">
                           <div className="card-body">
                              <h5 className="mb-3 text-start">Primary Contact Info</h5>
                              <div className="d-flex align-items-center mb-3">
                                 <span className="avatar avatar-md rounded me-2 flex-shrink-0 text-default" style={{ background: "#F8FAFC" }}>

                                    <img src={phoneIcon} alt="emailIcon" />

                                 </span>
                                 <div >
                                    <span className="text-dark font-weight-bold text-start">
                                       Phone Number
                                    </span>
                                    <p className="mb-0 text-start">
                                       {selectedWorker?.phone ?? "NA"}
                                    </p>
                                 </div>
                              </div>
                              <div className="d-flex align-items-center mb-3">
                                 <span className="avatar avatar-md rounded me-2 flex-shrink-0 text-default" style={{ background: "#F8FAFC" }}>

                                    <img src={phoneIcon} alt="emailIcon" />

                                 </span>
                                 <div >
                                    <span className="text-dark font-weight-bold text-start">
                                       Alternate Number
                                    </span>
                                    <p className="mb-0 text-start">
                                       {selectedWorker?.alternate_number ? selectedWorker?.alternate_number : "NA"}
                                    </p>
                                 </div>
                              </div>

                           </div>
                        </div>

                        <div className="card border-white">
                           <div className="card-body pb-1 ">
                              <h5 className="text-start">
                                 {(selectedWorker?.worker_type === ECategory?.BUSINESS_FIRM || selectedWorker?.has_firm) ? "Firm Pan Number" : "Pan Number / ID Number"}

                              </h5>
                              <div className="d-flex align-items-center justify-content-between">
                                 <div className="d-flex align-items-center ">
                                    <span className="avatar avatar-md rounded me-2 flex-shrink-0 text-default" style={{ background: "#F8FAFC" }}>
                                       <img src={idCard} alt="idCard" />
                                    </span>
                                    <div>
                                       {
                                          (selectedWorker?.worker_type === ECategory?.BUSINESS_FIRM || selectedWorker?.has_firm) ?
                                             <p className="text-dark mb-0" >
                                                {selectedWorker?.document_details?.firm_pan_number ? selectedWorker?.document_details?.firm_pan_number : "NA"}
                                             </p> :
                                             <p className="text-dark mb-0" >
                                                {selectedWorker?.document_details?.pan_number ? selectedWorker?.document_details?.pan_number : "NA"}
                                             </p>
                                       }

                                    </div>
                                 </div>
                                 {
                                    selectedWorker?.document_details?.pan_number || selectedWorker?.document_details?.firm_pan_number ?

                                       <button className="btn btn-icon btn-sm d-flex align-items-center justify-content-center" style={{ background: "#0d6efd" }} onClick={() => copyToClipboard("pan")}>
                                          <img src={copyIcon} alt="copyIcon" style={{ height: "13px", width: "13px" }} />
                                       </button>

                                       : ""
                                 }

                              </div>
                           </div>
                           <div className="card-body pb-1 ">
                              <h5 className="text-start">
                                 {(selectedWorker?.worker_type === ECategory?.BUSINESS_FIRM || selectedWorker?.has_firm) ? "Firm Gst Number" : "Aadhaar Number"}

                              </h5>
                              <div className="d-flex align-items-center justify-content-between">
                                 <div className="d-flex align-items-center mb-3">
                                    <span className="avatar avatar-md rounded me-2 flex-shrink-0 text-default" style={{ background: "#F8FAFC" }}>
                                       <img src={idCard} alt="idCard" />
                                    </span>
                                    <div>
                                       {
                                          (selectedWorker?.worker_type === ECategory?.BUSINESS_FIRM || selectedWorker?.has_firm) ?
                                             <p className="text-dark mb-0" >
                                                {selectedWorker?.document_details?.firm_gst_number ? selectedWorker?.document_details?.firm_gst_number : "NA"}
                                             </p> :
                                             <p className="text-dark mb-0" >
                                                {selectedWorker?.document_details?.adhaar_number ? selectedWorker?.document_details?.adhaar_number : "NA"}
                                             </p>
                                       }

                                    </div>
                                 </div>
                                 {
                                    selectedWorker?.document_details?.adhaar_number || selectedWorker?.document_details?.firm_gst_number ?
                                       <button className="btn btn-icon btn-sm d-flex align-items-center justify-content-center mb-3" style={{ background: "#0d6efd" }} onClick={() => copyToClipboard(selectedWorker?.document_details?.adhaar_number ? "aadhaar" : "firm_gst_number"
                                       )}>
                                          <img src={copyIcon} alt="copyIcon" style={{ height: "13px", width: "13px" }} />
                                       </button> : ""
                                 }

                              </div>
                           </div>
                        </div>
                        <div className="card border-white">
                           <div className="card-header" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                              <h5 className="mb-0 text-start">Bank Details</h5>
                           </div>

                           <div className="card-body">
                              <div className="mb-2 ">
                                 <p className="text-dark text-start font-weight-normal">Bank Name</p>
                                 <p className="text-start mt-0">{selectedWorker?.bank_details?.bank_name ? selectedWorker?.bank_details?.bank_name : "NA"} </p>
                              </div>
                              <div className="mb-2 ">
                                 <p className="text-dark text-start font-weight-normal">Account Number</p>
                                 <p className="text-start mt-0">{selectedWorker?.bank_details?.account_number ? selectedWorker?.bank_details?.account_number : "NA"} </p>
                              </div>
                              <div className="mb-2 ">
                                 <p className="text-dark text-start font-weight-normal">Account Holder Name</p>
                                 <p className="text-start mt-0">
                                    {selectedWorker?.bank_details?.account_holder_name ? selectedWorker?.bank_details?.account_holder_name : "NA"} </p>
                              </div>
                              <div className="mb-2">
                                 <p className="text-dark text-start font-weight-normal">IFSC Code</p>
                                 <p className="text-start mt-0">{selectedWorker?.bank_details?.IFSC_code ? selectedWorker?.bank_details?.IFSC_code : "NA"} </p>
                              </div>
                           </div>
                        </div>
                        <div className="card border-white">
                           <div className="card-header" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                              <h5 className="mb-0 text-start">Address</h5>
                           </div>

                           <div className="card-body">
                              <div className="d-flex align-items-center mb-3">
                                 <span className="avatar avatar-md rounded me-2 flex-shrink-0 text-default" style={{ background: "#F8FAFC" }}>

                                    <img src={currentAddress} alt="currentAddress" />

                                 </span>
                                 <div className="text-start">
                                    <span className="text-dark font-weight-bold">
                                       Current Address
                                    </span>
                                    <p className="mb-0 text-start">
                                       {`${selectedWorker?.address?.street ? selectedWorker?.address?.street + ", " + selectedWorker?.address?.landmark + ", " : ""} ${selectedWorker?.address?.city}, ${selectedWorker?.address?.state},
                      ${selectedWorker?.address?.pin_code} `}
                                    </p>
                                 </div>
                              </div>
                              <div className="d-flex align-items-center mb-3">
                                 <span className="avatar avatar-md rounded me-2 flex-shrink-0 text-default" style={{ background: "#F8FAFC" }}>

                                    <img src={permanentAddress} alt="permanentAddress" />

                                 </span>
                                 <div className="text-start">
                                    <span className="text-dark font-weight-bold">
                                       Permanent Address
                                    </span>
                                    <p className="mb-0 text-start">
                                       {`${selectedWorker?.address?.street ? selectedWorker?.address?.street + ", " : ""} ${selectedWorker?.address?.city}, ${selectedWorker?.address?.state},
                      ${selectedWorker?.address?.pin_code} `}
                                    </p>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="col-xxl-9 col-xl-8 p-2">
                     <div className="row ">
                        <div className="col-md-12">
                           <div>
                           <ul className="nav nav-tabs nav-tabs-bottom mb-4 border-bottom-0">
                              <li >
                                 <div className={` d-flex p-3 sidePages ${clickedSidePage?.workerDetails ? "active" : ""}`}
                                    onClick={() => {
                                       setHandlePageClick("workerDetails");
                                       setPaginatedData({
                                          ...PaginatedData,
                                          pageNo: 1
                                       });

                                    }}>
                                    <span className="d-flex justify-content-center align-items-center me-2" >
                                       <svg fill={clickedSidePage?.workerDetails ? "#3D5EE1" : "#000000"} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{ width: "13px", height: "13px" }}><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M15 11h7v2h-7zm1 4h6v2h-6zm-2-8h8v2h-8zM4 19h10v-1c0-2.757-2.243-5-5-5H7c-2.757 0-5 2.243-5 5v1h2zm4-7c1.995 0 3.5-1.505 3.5-3.5S9.995 5 8 5 4.5 6.505 4.5 8.5 6.005 12 8 12z"></path></g></svg>
                                       {/* <img src={userDetails} alt="worker-details" style={{ width: "13px", height: "13px" }} /> */}
                                    </span>
                                    <button className="border-0 bg-transparent">
                                       {selectedWorker?.worker_type === "sales_professional" ? "Sales Professional Details" : "   Worker Details"}

                                    </button>
                                 </div>
                              </li>
                              <li >
                                 <div className={` d-flex p-3 sidePages ${clickedSidePage?.transactions ? "active" : ""}`}
                                    onClick={() => {
                                       setHandlePageClick("transactions");
                                       setPaginatedData({
                                          ...PaginatedData,
                                          pageNo: 1
                                       });

                                    }}>
                                    <span className="d-flex justify-content-center align-items-center me-2">
                                       <svg version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xmlSpace="preserve" fill={clickedSidePage?.transactions ? "#3D5EE1" : "#000000"} style={{ width: "13px", height: "13px" }}><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <style type="text/css">  .st0  </style> <g> <polygon className="st0" points="373.103,133.628 369.368,133.628 358.087,133.628 354.353,133.628 354.353,164.581 349.165,167.909 336.806,167.909 336.806,133.628 336.759,133.628 320.712,133.628 318.196,133.628 318.196,167.909 292.665,167.909 292.665,189.19 318.196,189.19 318.196,223.472 320.712,223.472 336.759,223.472 336.806,223.472 336.806,189.19 349.196,189.19 354.353,192.519 354.353,223.472 358.087,223.472 369.368,223.472 373.103,223.472 373.103,204.597 397.524,220.269 397.524,217.878 397.524,202.237 397.524,199.847 364.399,178.534 397.524,157.253 397.524,154.862 397.524,139.222 397.524,136.815 373.103,152.519 "></polygon> <path className="st0" d="M462.321,245.8c-2.359,0-7.422,0-14.344,0c0.609-24.641,4.391-58.063,10.688-92.297 c6.859-37.516,16.719-76.172,28.078-105.484l-0.078-0.031c0.922-2.203,1.594-4.688,1.578-7.266 c0.016-3.906-1.281-7.484-2.891-10.094c-3.109-4.922-6.75-7.406-10.469-9.672c-6.516-3.781-14.172-6.438-23.297-8.953 c-13.641-3.672-30.375-6.625-48.328-8.719c-17.938-2.078-37.047-3.281-55.156-3.281c-29.469,0.016-61.5,3.141-86.953,8.188 c-12.781,2.563-23.828,5.5-32.719,9.234c-4.484,1.938-8.453,3.969-12.219,7.078c-1.875,1.578-3.75,3.484-5.375,6.125 c-1.594,2.609-2.891,6.203-2.875,10.094c-0.016,2.625,0.656,5.141,1.594,7.359l-0.063,0.031 c11.188,28.328,21.063,66.953,27.953,104.719c2.766,15,5.031,29.891,6.781,44c-39.734,11.047-60.047,74.109-101.297,74.109v180.75 c39.484,0,144.234,43.906,175.938,50.266c35.906,7.188,82.828,23.031,107.719-10.781c15.359-20.844,39.406-101.781,57.453-159.188 C529.837,287.987,498.228,245.8,462.321,245.8z M430.196,148.284c-6.547,35.828-10.547,70.5-11.156,97.516 c-48.406,0-121.281,0-141.875,0c-0.641-27.188-4.672-62.203-11.25-98.188c-4.234-23.109-9.516-46.422-15.625-68.094l2.109,2.859 c32-12.359,37.703-33.109,37.781-49.563c18.531-2.422,39.047-3.906,57.922-3.875c19.25-0.016,40.156,1.5,58.953,4.016 c0.484,16.141,6.859,35.875,37.734,47.797l1.391-1.906C439.884,101.065,434.509,124.831,430.196,148.284z"></path> <path className="st0" d="M5.181,306.081v157.125c0,19.422,15.734,35.156,35.156,35.156h41.938c12.953,0,23.453-10.5,23.453-23.438 V270.94H40.337C20.915,270.94,5.181,286.675,5.181,306.081z"></path> </g> </g></svg>
                                    </span>
                                    <button className="border-0 bg-transparent" >
                                       Transactions
                                    </button>
                                 </div>
                              </li>
                              {
                                 selectedWorker?.worker_type !== ECategory?.SELLER ?
                                    <li >
                                       <div className={` d-flex p-3 sidePages ${clickedSidePage?.earnings ? "active" : ""}`}
                                          onClick={() => {
                                             setHandlePageClick("earnings");
                                             // handleEarningsClick();
                                             setPaginatedData({
                                                ...PaginatedData,
                                                pageNo: 1
                                             });

                                          }}>
                                          <span className="d-flex justify-content-center align-items-center me-2" >
                                             <svg fill={clickedSidePage?.earnings ? "#3D5EE1" : "#000000"} version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 32.00 32.00" xmlSpace="preserve" stroke={clickedSidePage?.earnings ? "#3D5EE1" : "#000000"} strokeWidth="1.6001" style={{ width: "13px", height: "13px" }}><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g id="wallet"> <g> <path d="M30.984,13.797l-0.213-0.42h-1.9c-0.365-2.504-0.816-4.354-0.848-4.482l-0.201-0.814h-2.713l-3.08-6.43l-11.135,6.43 H1.993L1.761,8.836C1.688,9.07,0,14.611,0,19.29c0,4.681,1.69,10.088,1.763,10.313l0.236,0.748h25.823l0.201-0.812 c0.035-0.145,0.576-2.365,0.953-5.254h-2.164c-0.229,1.666-0.506,3.086-0.688,3.926H3.587c-0.451-1.613-1.445-5.549-1.445-8.922 c0-3.388,1-7.419,1.45-9.065h22.535c0.15,0.707,0.371,1.826,0.574,3.154h-9.486l-0.186,0.498c-0.042,0.109-1.01,2.717-1.01,4.949 c0,2.229,0.969,4.838,1.01,4.947l0.186,0.498h13.557l0.213-0.419c0.041-0.082,1.018-2.037,1.018-5.024 C32,15.834,31.025,13.879,30.984,13.797z M29.789,22.732h-11.49c-0.264-0.815-0.742-2.491-0.742-3.907 c0-1.418,0.479-3.095,0.742-3.911h11.49c0.248,0.662,0.672,2.063,0.672,3.911C30.461,20.668,30.037,22.07,29.789,22.732z"></path> <circle cx="21.615" cy="18.823" r="2.034"></circle> </g> </g> </g> </g></svg>
                                             {/* <img src={userDetails} alt="worker-details" style={{ width: "13px", height: "13px" }} /> */}
                                          </span>
                                          <button className="border-0 bg-transparent">
                                             Earning Details
                                          </button>
                                       </div>
                                    </li> : ""
                              }

                              {
                                 selectedWorker?.worker_type === ECategory?.SALES_PROFESSIONAL ?
                                    <li >
                                       <div className={` d-flex p-3 sidePages ${clickedSidePage?.leads ? "active" : ""}`}
                                          onClick={() => {
                                             setHandlePageClick("leads");
                                             // handleEarningsClick();
                                             setPaginatedData({
                                                ...PaginatedData,
                                                pageNo: 1
                                             });

                                          }}>
                                          <span className="d-flex justify-content-center align-items-center me-2" >

                                             <svg fill={clickedSidePage?.leads ? "#3D5EE1" : "#000000"} style={{ width: "13px", height: "13px" }} version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 787.3 787.3" xmlSpace="preserve"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <g> <path d="M393.3,172c0.1,0,0.2,0,0.399,0c0.101,0,0.2,0,0.4,0c47.3,0,85.599-38.3,85.599-85.6c0-7.5-1-14.8-2.799-21.7 c-9.5-36.9-43-64.2-82.9-64.2c-0.101,0-0.2,0-0.4,0c-0.1,0-0.2,0-0.4,0c-47.3-0.1-85.6,38.3-85.6,85.5c0,7.5,1,14.8,2.8,21.7 C319.899,144.7,353.399,172,393.3,172z"></path> <path d="M394.1,172.5h-0.8c-39.318,0-73.607-26.596-83.385-64.676C308.047,100.663,307.1,93.319,307.1,86 c0-47.421,38.542-86,85.915-86H394c39.307,0,73.595,26.554,83.384,64.575c1.867,7.163,2.814,14.507,2.814,21.825 C480.199,133.875,441.575,172.5,394.1,172.5z M393.015,1C346.192,1,308.1,39.131,308.1,86c0,7.234,0.937,14.492,2.784,21.574 c9.664,37.64,43.555,63.926,82.417,63.926h0.8c46.923,0,85.099-38.176,85.099-85.1c0-7.233-0.937-14.492-2.782-21.574 C466.741,27.246,432.85,1,394,1H393.015z"></path> </g> <path d="M483.8,207.9h-21.4L441,314.7h-25.301l-6.6-71.7c2-10.9,6.701-21.1,11.701-31.8c0,0,0.898-1.9,1.398-2.9l0,0 c-0.1,0-0.199,0-0.299,0c0.1-0.1,0.1-0.3,0.199-0.4c-30,0-27.599,0-57,0l0,0c0.1,0.1,0.1,0.2,0.2,0.4h-0.101l0,0 c0.5,1,1.4,2.9,1.4,2.9c4.4,9.3,8.5,18.2,10.8,27.6c0.3,1.3,0.601,2.6,0.8,3.9l-6.6,72.1h-25.3l-21.4-106.8H303.5 c-32.5,0-58.8,26.3-58.8,58.8v171.3c0,32.5,26.3,58.8,58.8,58.8h7.5v248.9c0,22.9,18.6,41.5,41.5,41.5 c21.3,0,38.899-16.1,41.199-36.9c2.3,20.7,19.9,36.9,41.201,36.9c22.9,0,41.5-18.6,41.5-41.5V496.7h7.5 c32.5,0,58.799-26.301,58.799-58.801V266.6C542.5,234.2,516.199,207.9,483.8,207.9z"></path> </g> <g> <path d="M615.4,172c0.1,0,0.199,0,0.4,0c0.1,0,0.199,0,0.398,0c47.301,0,85.602-38.3,85.602-85.6c0-7.5-1-14.8-2.801-21.7 c-9.5-36.9-43-64.2-82.9-64.2c-0.1,0-0.199,0-0.4,0c-0.1,0-0.199,0-0.398,0c-47.301,0-85.602,38.3-85.602,85.6 c0,7.5,1,14.8,2.801,21.7C542,144.7,575.5,172,615.4,172z"></path> <path d="M616.199,172.5H615.4c-39.307,0-73.596-26.554-83.385-64.576c-1.868-7.16-2.816-14.504-2.816-21.825 c0-47.476,38.625-86.1,86.102-86.1h0.799c39.307,0,73.596,26.554,83.385,64.575c1.868,7.16,2.816,14.504,2.816,21.825 C702.3,133.875,663.675,172.5,616.199,172.5z M615.3,1c-46.925,0-85.102,38.175-85.102,85.1c0,7.236,0.937,14.494,2.784,21.574 c9.676,37.581,43.566,63.827,82.417,63.827h0.799c46.925,0,85.102-38.176,85.102-85.1c0-7.236-0.937-14.494-2.784-21.574 C688.84,27.246,654.95,1,616.099,1H615.3z"></path> </g> <path d="M705.9,207.9h-21.4l-21.4,106.8H637.8l-6.602-71.7c2-10.9,6.701-21.1,11.701-31.8c0,0,0.9-1.9,1.4-2.9 c-0.102,0-0.201,0-0.301,0c0.1-0.1,0.1-0.3,0.199-0.4c-30,0-27.6,0-57,0l0,0c0.102,0.1,0.102,0.2,0.201,0.4h-0.1l0,0 c0.5,1,1.398,2.9,1.398,2.9c4.4,9.3,8.5,18.2,10.801,27.6c0.301,1.3,0.6,2.6,0.801,3.9l-6.602,72.1h-23v123.3 c0,29.601-14.898,55.8-37.6,71.4v236.3c0,22.9,18.6,41.5,41.5,41.5c21.301,0,38.9-16.1,41.201-36.9 c2.299,20.7,19.9,36.9,41.199,36.9c22.9,0,41.5-18.6,41.5-41.5V496.7h7.5c32.5,0,58.801-26.301,58.801-58.801V266.6 C764.599,234.2,738.3,207.9,705.9,207.9z"></path> <g> <path d="M171.2,172c0.1,0,0.2,0,0.4,0c0.1,0,0.2,0,0.4,0c47.3,0,85.6-38.3,85.6-85.6c0-7.5-1-14.8-2.8-21.7 c-9.5-36.9-43-64.2-82.9-64.2c-0.1,0-0.2,0-0.4,0c-0.1,0-0.2,0-0.4,0c-47.3,0-85.6,38.3-85.6,85.6c0,7.5,1,14.8,2.8,21.7 C97.8,144.7,131.3,172,171.2,172z"></path> <path d="M172,172.5h-0.8c-39.307,0-73.595-26.554-83.384-64.576C85.947,100.763,85,93.42,85,86.1C85,38.624,123.624,0,171.1,0h0.8 c39.307,0,73.596,26.554,83.385,64.575c1.868,7.162,2.815,14.505,2.815,21.825C258.1,133.875,219.475,172.5,172,172.5z M171.1,1 C124.175,1,86,39.175,86,86.1c0,7.235,0.937,14.494,2.784,21.574C98.459,145.254,132.35,171.5,171.2,171.5h0.8 c46.924,0,85.1-38.176,85.1-85.1c0-7.234-0.937-14.493-2.784-21.574C244.641,27.246,210.75,1,171.899,1H171.1z"></path> </g> <path d="M216.6,438V314.7h-23L187,243c2-10.9,6.7-21.1,11.7-31.8c0,0,0.9-1.9,1.4-2.9c-0.1,0-0.2,0-0.3,0c0.1-0.1,0.1-0.3,0.2-0.4 c-30,0-27.6,0-57,0l0,0c0.1,0.1,0.1,0.2,0.2,0.4h-0.1l0,0c0.5,1,1.4,2.9,1.4,2.9c4.4,9.3,8.5,18.2,10.8,27.6 c0.3,1.3,0.6,2.6,0.8,3.9l-6.6,72.1h-25.3L102.8,208H81.3c-32.5,0-58.8,26.3-58.8,58.8v171.3c0,32.5,26.3,58.8,58.8,58.8h7.5v248.9 c0,22.9,18.6,41.5,41.5,41.5c21.3,0,38.9-16.1,41.2-36.9c2.3,20.7,19.9,36.9,41.2,36.9c22.9,0,41.5-18.6,41.5-41.5v-236.4 C231.5,493.7,216.6,467.6,216.6,438z"></path> </g> </g></svg>
                                          </span>
                                          <button className="border-0 bg-transparent">
                                             New Leads
                                          </button>
                                       </div>
                                    </li> :
                                    <li >
                                       <div className={` d-flex p-3 sidePages ${clickedSidePage?.ratings ? "active" : ""}`}
                                          onClick={() => {
                                             setHandlePageClick("ratings");
                                             setPaginatedData({
                                                ...PaginatedData,
                                                pageNo: 1
                                             });

                                          }}>
                                          <span className="d-flex justify-content-center align-items-center me-2" >
                                             <svg fill={clickedSidePage?.ratings ? "#3D5EE1" : "#000000"} height="200px" width="200px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xmlSpace="preserve" style={{ width: "13px", height: "13px" }}><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path d="M501.108,324.808c-18.078-22.785-51.248-26.095-73.455-7.46l-79.115,66.383h-37.109 c18.518-7.578,31.898-25.423,32.467-46.178c0.797-29.075-22.487-52.931-51.476-52.931H137.134v-15.706 c0-9.222-7.477-16.699-16.699-16.699H16.699C7.477,252.218,0,259.695,0,268.917v213.755c0,9.222,7.477,16.699,16.699,16.699 h103.737c9.222,0,16.699-7.477,16.699-16.699v-27.328l32.695,27.43c9.006,7.557,20.442,11.718,32.199,11.718h156.499 c11.758,0,23.194-4.162,32.201-11.719L493.3,396.711C514.768,378.695,518.272,346.441,501.108,324.808z M103.737,465.972H33.398 V285.615h70.339C103.737,296.354,103.737,458.287,103.737,465.972z M471.83,371.125l-102.571,86.063 c-3.002,2.519-6.814,3.906-10.734,3.906H202.027c-3.919,0-7.73-1.387-10.733-3.906l-54.161-45.44v-93.727h155.286 c10.134,0,18.373,8.324,18.092,18.619c-0.266,9.692-8.706,17.577-18.815,17.577c-7.262,0-59.115,0-65.689,0 c-9.222,0-16.699,7.477-16.699,16.699s7.477,16.699,16.699,16.699h29.59l25.868,21.703c6.005,5.037,13.628,7.813,21.467,7.813 h45.607c7.838,0,15.462-2.774,21.468-7.814l79.115-66.383c7.76-6.511,19.424-5.432,25.824,2.634 C480.972,353.162,479.575,364.628,471.83,371.125z"></path> </g> </g> <g> <g> <path d="M368.08,92.437l-67.065-9.744l-29.992-60.772c-6.113-12.386-23.833-12.393-29.949,0l-29.992,60.772l-67.065,9.744 c-13.669,1.987-19.151,18.836-9.255,28.483l48.528,47.306l-11.457,66.794c-2.336,13.613,11.995,24.034,24.229,17.604 l59.986-31.536l59.984,31.535c12.157,6.392,26.58-3.898,24.229-17.604l-11.457-66.794l48.529-47.305 C387.225,111.279,381.757,94.424,368.08,92.437z M301.626,207.317c-54.351-28.574-36.583-28.69-91.155,0 c10.384-60.549,15.947-43.691-28.169-86.694c60.547-8.798,46.15,2.338,73.747-53.579c27.188,55.09,12.78,44.721,73.745,53.579 C285.814,163.494,291.21,146.586,301.626,207.317z"></path> </g> </g> </g></svg>

                                          </span>
                                          <button className="border-0 bg-transparent">
                                             Worker Ratings
                                          </button>
                                       </div>
                                    </li>
                              }


                           </ul>
                              <div className='d-flex justify-content-end'>
                                 <Link to={selectedWorker?.has_membership ? `/workers/edit/${selectedWorker?._id}` : "#"}
                                    style={{ pointerEvents: selectedWorker?.has_membership ? "auto" : "none" }}>
                                    <button
                                       className={`py-2 px-3 text-dark font-weight-normal ${selectedWorker?.has_membership ? "hover-effect" : ''}`}>
                                       Edit Profile
                                    </button>
                                 </Link>

                              </div>

                           </div>

                           {
                              clickedSidePage?.transactions ?
                                 <div className="card">
                                    <div className="card-header" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                                       <h5 className="text-start mb-0" >
                                          My Transactions
                                       </h5>
                                       <div className="d-flex justify-content-end mb-3 gap-4">
                                          <div className="d-flex gap-2">
                                             <span className="d-flex align-items-center pagesize-text">
                                                PageSize
                                             </span>

                                             <select
                                                className="form-select"
                                                style={{ backgroundPosition: "right 5px center", width: "60px" }}
                                                aria-label="Default select example"
                                                value={PaginatedData?.pageSize} // Bind the value to the state
                                                onChange={handlePageSizeChange} // Handle the change
                                             >
                                                <option value={20}>20</option>
                                                <option value={50}>50</option>
                                                <option value={100}>100</option>
                                                <option value={200}>200</option>
                                             </select>
                                             <ExportDocs headers={headersForTransaction} formattedData={formattedDataForTransaction} clickHandler={exportPdfForTransaction} />
                                          </div>

                                       </div>
                                    </div>
                                    <div className="card-body">
                                       <div className="border rounded p-3 pb-0 transaction-body" >
                                          <div className="table-responsive">
                                             <table className="table  card-body">
                                                <thead>
                                                   <tr className="transaction-tr">
                                                      <th scope="col" className="text-start ps-4">Sr.No.</th>
                                                      <th scope="col" className="text-start ps-4">Order Name</th>
                                                      <th scope="col" className="text-start ps-4">Order Type</th>
                                                      <th scope="col" className="text-start ps-4">Transaction ID</th>
                                                      <th scope="col" className="text-start ps-4">Amount</th>
                                                      <th scope="col" className="text-start ps-4">Status</th>
                                                      <th scope="col" className="text-start ps-4">Date</th>
                                                      <th scope="col" className="col-lg-2 ps-4 ">Action</th>
                                                   </tr>
                                                </thead>
                                                <tbody>
                                                   {
                                                      transactions && transactions?.map((data: ITransactions, i) => {
                                                         // const createdAt = moment(data?.createdAt).tz('Asia/Kolkata').format('DD-MM-YYYY');
                                                         const createdAt = formatDiffrentDate(data?.createdAt);
                                                         const rowNumber = (PaginatedData?.pageNo - 1) * PaginatedData?.pageSize + (i + 1);

                                                         return (
                                                            <tr key={data?._id}>


                                                               <td className="text-start align-content-center ps-4">
                                                                  <span className="">
                                                                     {rowNumber}
                                                                  </span>

                                                               </td>
                                                               <td className="text-start align-content-center ps-4">
                                                                  <span className="">
                                                                     {data?.order_name}
                                                                  </span>

                                                               </td>
                                                               <td className="text-start align-content-center ps-4">
                                                                  <span className="">
                                                                     {formatCategory(data?.order_type)}
                                                                  </span>

                                                               </td>

                                                               <td className="text-start align-content-center ps-4">
                                                                  <span className="">
                                                                     {data?.unique_id}
                                                                  </span>

                                                               </td>

                                                               <td className="text-start align-content-center ps-4 ">
                                                                  <span className=" align-items-center">
                                                                     &#8377; {data?.payment_amount?.toFixed(2)}
                                                                  </span> </td>

                                                               <td className="icon-td align-content-center text-start ps-4">
                                                                  {data?.status ? "Success" : "Failed"}
                                                               </td>
                                                               <td className="text-start align-content-center ps-4" width={"160px"}>
                                                                  <span className="" >
                                                                     {createdAt?.formattedDate}
                                                                  </span>

                                                               </td>
                                                               <td className="align-content-center ">
                                                                  <div className="d-flex justify-content-center gap-3 align-items-center">


                                                                     <button
                                                                        className="btn btn-sm delete_btn"
                                                                        onClick={() => handleInvoiceClick(data?.order_id, data?.order_type)}
                                                                        style={{ marginBottom: "1px" }}
                                                                     >
                                                                        <img src={bill} alt="invoice" />
                                                                     </button>

                                                                  </div>

                                                               </td>
                                                            </tr>
                                                         )
                                                      }
                                                      )
                                                   }

                                                </tbody>
                                             </table>
                                             {
                                                loading ? <LoadingGif /> : ""
                                             }
                                          </div>
                                          <Paginator
                                             totalPages={PaginatedData?.totalPages}
                                             pageNo={PaginatedData?.pageNo}
                                             onPageChange={(e, no) => setPaginatedData({
                                                ...PaginatedData,
                                                pageNo: no

                                             })}
                                             alignment="right"
                                          />
                                       </div>

                                    </div>

                                 </div>

                                 :
                                 clickedSidePage?.workerDetails ?
                                    <div>
                                       <div className="card">
                                          <div className="card-header" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                                             <h5 className="text-start mb-0" >
                                                Profile Details
                                             </h5>

                                          </div>
                                          <div className="card-body">
                                             <div className="border rounded p-3 pb-0">
                                                <div className="row">
                                                   {
                                                      selectedWorker?.worker_type !== ECategory?.BUSINESS_FIRM ?
                                                         <>
                                                            <div className="col-sm-6 col-lg-4">
                                                      <div className="mb-3 ">
                                                         <p className="text-dark text-start font-weight-normal mb-1">Qualification</p>
                                                         <p className="text-start">{selectedWorker?.qualification ? selectedWorker?.qualification : "NA"} </p>
                                                      </div>
                                                            </div> 
                                                            <div className="col-sm-6 col-lg-4">
                                                               <div className="mb-3 ">
                                                                  <p className="text-dark text-start font-weight-normal mb-1">Date Of Birth</p>
                                                                  <p className="text-start">{selectedWorker?.date_of_birth ? selectedWorker?.date_of_birth : "NA"} </p>
                                                               </div>
                                                            </div>
                                                         </>

                                                         : ""
                                                   }

                                                   {
                                                      (selectedWorker?.worker_type === ECategory?.BUSINESS_FIRM) || (selectedWorker?.worker_type === ECategory?.SELLER) ?
                                                         <>

                                                            <div className="col-sm-6 col-lg-4">
                                                               <div className="mb-3 ">
                                                                  <p className="text-dark text-start font-weight-normal mb-1">Firm Name</p>
                                                                  <p className="text-start">{selectedWorker?.firm_name ?? "NA"} </p>
                                                               </div>
                                                            </div>
                                                            {
                                                               (selectedWorker?.worker_type === ECategory?.BUSINESS_FIRM) ?
                                                                  <div className="col-sm-6 col-lg-4">
                                                                     <div className="mb-3 ">
                                                                        <p className="text-dark text-start font-weight-normal mb-1">Firm Age</p>
                                                                        <p className="text-start">{selectedWorker?.document_details?.firm_age ?? "NA"} </p>
                                                                     </div>
                                                                  </div> : ''
                                                            }

                                                         </>

                                                         : ''
                                                   }


                                                   <div className="col-sm-6 col-lg-4">
                                                      <div className="mb-3 ">
                                                         <p className="text-dark text-start font-weight-normal mb-1">Has Memberhsip</p>
                                                         <p className="text-start">{selectedWorker?.has_membership ? "Yes" : "No"} </p>
                                                      </div>
                                                   </div>
                                                   <div className="col-sm-6 col-lg-4">
                                                      <div className="mb-3 ">
                                                         <p className="text-dark text-start font-weight-normal mb-1">Has Subscription</p>
                                                         <p className="text-start">{selectedWorker?.has_subscription ? "Yes" : "No"} </p>
                                                      </div>
                                                   </div>
                                                   <div className="col-sm-6 col-lg-4">
                                                      <div className="mb-3 ">
                                                         <p className="text-dark text-start font-weight-normal mb-1">Is Online</p>
                                                         <p className="text-start">{selectedWorker?.is_online ? "Yes" : "No"} </p>
                                                      </div>
                                                   </div>
                                                   <div className="col-sm-6 col-lg-4">
                                                      <div className="mb-3 ">
                                                         <p className="text-dark text-start font-weight-normal mb-1"> Bank Details</p>
                                                         <p className="text-start">{selectedWorker?.is_basic_details_completed ? "Completed" : "Pending"} </p>
                                                      </div>
                                                   </div>
                                                   <div className="col-sm-6 col-lg-4">
                                                      <div className="mb-3 ">
                                                         <p className="text-dark text-start font-weight-normal mb-1">Basic Details</p>
                                                         <p className="text-start">{selectedWorker?.is_basic_details_completed ? "Completed" : "Incompleted"} </p>
                                                      </div>
                                                   </div>
                                                   <div className="col-sm-6 col-lg-4">
                                                      <div className="mb-3 ">
                                                         <p className="text-dark text-start font-weight-normal mb-1">Document Details</p>
                                                         <p className="text-start">{selectedWorker?.is_document_details_completed ? "Completed" : "Incompleted"} </p>
                                                      </div>
                                                   </div>
                                                   <div className="col-sm-6 col-lg-4">
                                                      <div className="mb-3 ">
                                                         <p className="text-dark text-start font-weight-normal mb-1">Used Referral</p>
                                                         <p className="text-start">{selectedWorker?.referral_code ? selectedWorker?.referral_code : "NA"} </p>
                                                      </div>
                                                   </div>
                                                   <div className="col-sm-6 col-lg-4">
                                                      <div className="mb-3 ">
                                                         <p className="text-dark text-start font-weight-normal mb-1">Is Account Verified</p>
                                                         <p className="text-start">{selectedWorker?.is_verified ? "Yes" : "No"} </p>
                                                      </div>
                                                   </div>
                                                   <div className="col-sm-6 col-lg-4">
                                                      <div className="mb-3 ">
                                                         <p className="text-dark text-start font-weight-normal mb-1">Is Account Activated</p>
                                                         <p className="text-start">{selectedWorker?.is_activated_account ? "Yes" : "No"} </p>
                                                      </div>
                                                   </div>
                                                   {
                                                      [ECategory?.ARCHITECT, ECategory?.ENGINEER]
                                                         ?.includes(selectedWorker?.worker_type as ECategory) ?
                                                         <div className="col-sm-6 col-lg-4">
                                                            <div className="mb-3">
                                                               <p className="text-dark text-start font-weight-normal mb-1">Own a Firm</p>
                                                               <p className="text-start">{selectedWorker?.has_firm ? "Yes" : "No"} </p>
                                                            </div>
                                                         </div> : ""
                                                   }

                                                   <div className="col-12">
                                                      <div className="mb-3 ">
                                                         <p className="text-dark text-start font-weight-normal mb-1">Bio</p>
                                                         <p className="text-start">{selectedWorker?.bio || "NA"} </p>
                                                      </div>
                                                   </div>

                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                       <div className="col-xxl-12">
                                          <div className="card">
                                             <div className="card-header text-start" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                                                <h5 className="mb-0">
                                                   Document Details
                                                </h5>
                                             </div>
                                             <div className="card-body pb-1" >
                                                <div className="row">
                                                   <div className="col-md-4">
                                                      <div className="mb-4">
                                                         <p className="text-dark font-weight-normal text-start mb-3">
                                                            {(selectedWorker?.worker_type === ECategory?.BUSINESS_FIRM || selectedWorker?.has_firm)
                                                               ? "Firm Gst Image" : selectedWorker?.worker_type === ECategory?.SELLER ? "Shop Image 1" : "Aadhar Front Image"}
                                                         </p>
                                                         {/* <div className="d-flex justify-content-start align-items-center doc-div"> */}
                                                         {(selectedWorker?.worker_type === ECategory?.BUSINESS_FIRM || selectedWorker?.has_firm) ?
                                                            (
                                                            <LightGallery
                                                               plugins={[lgZoom, lgHash]}
                                                               mobileSettings={{
                                                                  controls: false,
                                                                  showCloseIcon: false,
                                                                  download: false,
                                                                  rotate: false,

                                                               }}
                                                               elementClassNames="d-flex justify-content-start align-items-center doc-div"
                                                               mode="lg-fade">
                                                               <a
                                                                  data-src={
                                                                     selectedWorker?.document_details?.firm_gst_pic
                                                                        ? typeof selectedWorker?.document_details?.firm_gst_pic === "string"
                                                                           ? selectedWorker?.document_details?.firm_gst_pic
                                                                           : URL.createObjectURL(selectedWorker?.document_details?.firm_gst_pic)
                                                                        : placeholderImg
                                                                  }
                                                                  className="w-100 h-100 d-flex "
                                                               >
                                                                  <img
                                                                     src={
                                                                        selectedWorker?.document_details?.firm_gst_pic
                                                                           ? typeof selectedWorker?.document_details?.firm_gst_pic === "string"
                                                                              ? selectedWorker?.document_details?.firm_gst_pic
                                                                              : URL.createObjectURL(selectedWorker?.document_details?.firm_gst_pic)
                                                                           : placeholderImg
                                                                     }
                                                                     alt="firm_gst_pic"
                                                                     className="img-responsive"
                                                                     style={{ cursor: "pointer" }}
                                                                  />
                                                               </a>
                                                            </LightGallery>
                                                            ) :
                                                            selectedWorker?.worker_type === ECategory?.SELLER ?
                                                               (
                                                                  <LightGallery
                                                                     plugins={[lgZoom, lgHash]}
                                                                     mobileSettings={{
                                                                        controls: false,
                                                                        showCloseIcon: false,
                                                                        download: false,
                                                                        rotate: false,

                                                                     }}
                                                                     elementClassNames="d-flex justify-content-start align-items-center doc-div"
                                                                     mode="lg-fade">
                                                                     <a
                                                                        data-src={
                                                                           selectedWorker?.document_details?.seller_shop_pic1
                                                                              ? typeof selectedWorker?.document_details?.seller_shop_pic1 === "string"
                                                                                 ? selectedWorker?.document_details?.seller_shop_pic1
                                                                                 : URL.createObjectURL(selectedWorker?.document_details?.seller_shop_pic1)
                                                                              : placeholderImg
                                                                        }
                                                                        className="w-100 h-100 d-flex "
                                                                     >
                                                                        <img
                                                                           src={
                                                                              selectedWorker?.document_details?.seller_shop_pic1
                                                                                 ? typeof selectedWorker?.document_details?.seller_shop_pic1 === "string"
                                                                                    ? selectedWorker?.document_details?.seller_shop_pic1
                                                                                    : URL.createObjectURL(selectedWorker?.document_details?.seller_shop_pic1)
                                                                                 : placeholderImg
                                                                           }
                                                                           alt="firm_gst_pic"
                                                                           className="img-responsive"
                                                                           style={{ cursor: "pointer" }}
                                                                        />
                                                                     </a>
                                                                  </LightGallery>
                                                               )
                                                               :
                                                               (
                                                            <LightGallery
                                                               plugins={[lgZoom, lgHash]}
                                                               mobileSettings={{
                                                                  controls: false,
                                                                  showCloseIcon: false,
                                                                  download: false,
                                                                  rotate: false,
                                                               }}
                                                               elementClassNames="d-flex justify-content-start align-items-center doc-div"
                                                               mode="lg-fade"
                                                            >
                                                               <a
                                                                  data-src={
                                                                     selectedWorker?.document_details?.adhaar_front_pic
                                                                        ? typeof selectedWorker?.document_details?.adhaar_front_pic === "string"
                                                                           ? selectedWorker?.document_details?.adhaar_front_pic
                                                                           : URL.createObjectURL(selectedWorker?.document_details?.adhaar_front_pic)
                                                                        : placeholderImg
                                                                  }
                                                                  className="w-100 h-100 d-flex "
                                                               >
                                                                  <img
                                                                     src={
                                                                        selectedWorker?.document_details?.adhaar_front_pic
                                                                           ? typeof selectedWorker?.document_details?.adhaar_front_pic === "string"
                                                                              ? selectedWorker?.document_details?.adhaar_front_pic
                                                                              : URL.createObjectURL(selectedWorker?.document_details?.adhaar_front_pic)
                                                                           : placeholderImg
                                                                     }
                                                                     alt="adhaar_front_pic"
                                                                     className="img-responsive"
                                                                     style={{ cursor: "pointer" }}
                                                                  />
                                                               </a>
                                                            </LightGallery>
                                                         )}

                                                      </div>
                                                   </div>
                                                   <div className="col-md-4">
                                                      <div className="mb-4">
                                                         <p className="text-dark  font-weight-normal text-start  mb-3">
                                                            {(selectedWorker?.worker_type === ECategory?.BUSINESS_FIRM || selectedWorker?.has_firm) ? "Firm Pan Image" : selectedWorker?.worker_type === ECategory?.SELLER ? "Shop Image 2" : "Aadhaar Back Image"}
                                                         </p>

                                                         {
                                                            (selectedWorker?.worker_type === ECategory?.BUSINESS_FIRM || selectedWorker?.has_firm) ?
                                                               (
                                                                  <LightGallery
                                                                     plugins={[lgZoom, lgHash]}
                                                                     mobileSettings={{
                                                                        controls: false,
                                                                        showCloseIcon: false,
                                                                        download: false,
                                                                        rotate: false,
                                                                     }}
                                                                     mode="lg-fade"
                                                                     elementClassNames="d-flex justify-content-start align-items-center doc-div"
                                                                  >
                                                                     <a
                                                                        data-src={
                                                                           selectedWorker?.document_details?.firm_pan_pic
                                                                              ? typeof selectedWorker?.document_details?.firm_pan_pic === 'string'
                                                                                 ? selectedWorker?.document_details?.firm_pan_pic
                                                                                 : URL.createObjectURL(selectedWorker?.document_details?.firm_pan_pic)
                                                                              : placeholderImg
                                                                        }
                                                                        className="w-100 h-100 d-flex "
                                                                     >
                                                                        <img
                                                                           src={
                                                                              selectedWorker?.document_details?.firm_pan_pic
                                                                                 ? typeof selectedWorker?.document_details?.firm_pan_pic === 'string'
                                                                                    ? selectedWorker?.document_details?.firm_pan_pic
                                                                                    : URL.createObjectURL(selectedWorker?.document_details?.firm_pan_pic)
                                                                                 : placeholderImg
                                                                           }
                                                                           alt="firm_pan_pic"
                                                                           className="img-responsive"

                                                                        />
                                                                     </a>
                                                                  </LightGallery>
                                                               ) :
                                                               selectedWorker?.worker_type === ECategory?.SELLER ?
                                                                  (
                                                                     <LightGallery
                                                                        plugins={[lgZoom, lgHash]}
                                                                        mobileSettings={{
                                                                           controls: false,
                                                                           showCloseIcon: false,
                                                                           download: false,
                                                                           rotate: false,
                                                                        }}
                                                                        mode="lg-fade"
                                                                        elementClassNames="d-flex justify-content-start align-items-center doc-div"
                                                                     >
                                                                        <a
                                                                           data-src={
                                                                              selectedWorker?.document_details?.seller_shop_pic2
                                                                                 ? typeof selectedWorker?.document_details?.seller_shop_pic2 === 'string'
                                                                                    ? selectedWorker?.document_details?.seller_shop_pic2
                                                                                    : URL.createObjectURL(selectedWorker?.document_details?.seller_shop_pic2)
                                                                                 : placeholderImg
                                                                           }
                                                                           className="w-100 h-100 d-flex "
                                                                        >
                                                                           <img
                                                                              src={
                                                                                 selectedWorker?.document_details?.seller_shop_pic2
                                                                                    ? typeof selectedWorker?.document_details?.seller_shop_pic2 === 'string'
                                                                                       ? selectedWorker?.document_details?.seller_shop_pic2
                                                                                       : URL.createObjectURL(selectedWorker?.document_details?.seller_shop_pic2)
                                                                                    : placeholderImg
                                                                              }
                                                                              alt="firm_pan_pic"
                                                                              className="img-responsive"

                                                                           />
                                                                        </a>
                                                                     </LightGallery>
                                                                  )
                                                                  :
                                                               (<LightGallery
                                                                  plugins={[lgZoom, lgHash]}
                                                                  mobileSettings={{
                                                                     controls: false,
                                                                     showCloseIcon: false,
                                                                     download: false,
                                                                     rotate: false,
                                                                  }}
                                                                  mode="lg-fade"
                                                                  elementClassNames="d-flex justify-content-start align-items-center doc-div"
                                                               >
                                                                  <a
                                                                     data-src={
                                                                        selectedWorker?.document_details?.adhaar_back_pic
                                                                           ? typeof selectedWorker?.document_details?.adhaar_back_pic === 'string'
                                                                              ? selectedWorker?.document_details?.adhaar_back_pic
                                                                              : URL.createObjectURL(selectedWorker?.document_details?.adhaar_back_pic)
                                                                           : placeholderImg
                                                                     }
                                                                     className="w-100 h-100 d-flex "
                                                                  >
                                                                     <img
                                                                        src={
                                                                           selectedWorker?.document_details?.adhaar_back_pic
                                                                              ? typeof selectedWorker?.document_details?.adhaar_back_pic === 'string'
                                                                                 ? selectedWorker?.document_details?.adhaar_back_pic
                                                                                 : URL.createObjectURL(selectedWorker?.document_details?.adhaar_back_pic)
                                                                              : placeholderImg
                                                                        }
                                                                        alt="adhaar_back_pic"
                                                                        className="img-responsive"

                                                                     />
                                                                  </a>
                                                               </LightGallery>)
                                                         }


                                                      </div>
                                                   </div>
                                                   {((selectedWorker?.worker_type !== ECategory?.BUSINESS_FIRM && selectedWorker?.worker_type !== ECategory?.SELLER) && !selectedWorker?.has_firm) ?
                                                      <div className="col-md-4">
                                                         <div className="mb-4">
                                                            <p className="text-dark font-weight-normal text-start  mb-3">
                                                               Pancard Image
                                                            </p>

                                                            <LightGallery
                                                               plugins={[lgZoom, lgHash]}
                                                               mobileSettings={{
                                                                  controls: false,
                                                                  showCloseIcon: false,
                                                                  download: false,
                                                                  rotate: false,
                                                               }}
                                                               elementClassNames="d-flex justify-content-start align-items-center doc-div"
                                                               mode="lg-fade"
                                                            >
                                                               <a data-src={
                                                                  selectedWorker?.document_details?.pan_front_pic
                                                                     ? typeof selectedWorker?.document_details?.pan_front_pic === 'string'
                                                                        ? selectedWorker?.document_details?.pan_front_pic
                                                                        : URL.createObjectURL(selectedWorker?.document_details?.pan_front_pic)
                                                                     : placeholderImg
                                                               }
                                                                  className="w-100 h-100 d-flex "
                                                               >
                                                                  <img src={
                                                                     selectedWorker?.document_details?.pan_front_pic
                                                                        ? typeof selectedWorker?.document_details?.pan_front_pic === 'string'
                                                                           ? selectedWorker?.document_details?.pan_front_pic
                                                                           : URL.createObjectURL(selectedWorker?.document_details?.pan_front_pic)
                                                                        : placeholderImg
                                                                  }
                                                                     alt="pan_front_pic"
                                                                     className="img-responsive"
                                                                  />
                                                               </a>
                                                            </LightGallery>

                                                         </div>
                                                      </div>
                                                      : ""
                                                   }


                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                       {
                                          (selectedWorker?.your_work !== undefined) && (selectedWorker?.your_work?.length > 0) &&
                                          <div className="col-xxl-12">
                                             <div className="card">
                                                <div className="card-header text-start" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                                                   <h5 className="mb-0">
                                                      Worker's Work Images
                                                   </h5>
                                                </div>
                                                <div className="card-body pb-1" >
                                                   <div className="row">
                                                      {selectedWorker?.your_work?.length > 0 && (
                                                         <LightGallery
                                                            plugins={[lgZoom, lgShare, lgHash]}
                                                            elementClassNames="d-flex flex-wrap"
                                                            mobileSettings={{
                                                               controls: true,
                                                               showCloseIcon: true,
                                                               download: true,
                                                               rotate: false,
                                                            }}
                                                            mode="lg-fade"
                                                         >
                                                            {selectedWorker?.your_work.map((img, i) => (
                                                               <a
                                                                  key={i}
                                                                  data-src={
                                                                     img
                                                                        ? typeof img === "string"
                                                                           ? img
                                                                           : URL.createObjectURL(img)
                                                                        : placeholderImg
                                                                  }
                                                                  className="col-md-4 mb-3 pe-3"

                                                               >
                                                                  <img
                                                                     src={
                                                                        img
                                                                           ? typeof img === "string"
                                                                              ? img
                                                                              : URL.createObjectURL(img)
                                                                           : placeholderImg
                                                                     }
                                                                     alt={`Image ${i}`}
                                                                     className="w-100 h-auto"
                                                                     style={{ cursor: "pointer" }}
                                                                  />
                                                               </a>
                                                            ))}
                                                         </LightGallery>
                                                      )}
                                                   </div>

                                                </div>
                                             </div>
                                          </div>
                                       }
                                    </div>
                                    : clickedSidePage?.leads ?
                                       <div className="card">
                                          <div className="card-header d-flex justify-content-between" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                                             <h5 className="text-start mb-0" >
                                                New Leads
                                             </h5>

                                             <div className="d-flex justify-content-end mb-3 gap-4">
                                                <div className='d-flex gap-2 align-items-center' style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                                                   <span className='text-dark font-weight-bold'>Total Leads:</span>
                                                   <span className='text-dark font-weight-bold'>{totalData?.totalLeads}</span>
                                                </div>
                                                <div className="d-flex gap-2">
                                                   <span className="d-flex align-items-center pagesize-text" >
                                                      PageSize
                                                   </span>

                                                   <select
                                                      className="form-select"
                                                      style={{ backgroundPosition: "right 5px center", width: "60px" }}
                                                      aria-label="Default select example"
                                                      value={PaginatedData?.pageSize} // Bind the value to the state
                                                      onChange={handlePageSizeChange} // Handle the change
                                                   >
                                                      <option value={10}>10</option>
                                                      <option value={20}>20</option>
                                                      <option value={50}>50</option>
                                                      <option value={100}>100</option>
                                                      <option value={200}>200</option>
                                                   </select>
                                                   <ExportDocs headers={headersForLeads} formattedData={formattedDataForLeads} clickHandler={exportPdfForLeads} />
                                                </div>

                                             </div>
                                          </div>
                                          <div className="card-body">
                                             <div className="border rounded p-3 pb-0 transaction-body" >
                                                <div className="table-responsive">
                                                   <table className="table card-body">
                                                      <thead>
                                                         <tr className="transaction-tr">
                                                            <th scope="col" className="text-start ps-4">Sr.No.</th>
                                                            <th scope="col" className="text-start ps-4">Profile Pic</th>
                                                            <th scope="col" className="text-start ps-4">Name</th>
                                                            <th scope="col" className="text-start ps-4">Worker Type</th>
                                                            <th scope="col" className="text-start ps-4">Phone</th>
                                                            <th scope="col" className="text-start ps-4">Service</th>
                                                            <th scope="col" className="text-start ps-4">Subscription Type</th>
                                                            {/* <th scope="col" className="text-start ps-4">Used Referral</th> */}
                                                            <th scope="col" className="text-start ps-4">Joined At</th>
                                                            <th scope="col" className="col-lg-2 ps-4 ">Action</th>

                                                         </tr>
                                                      </thead>
                                                      <tbody>
                                                         {
                                                            earningsArray && earningsArray?.map((data, i) => {
                                                               // const createdAt = moment(data?.createdAt).tz('Asia/Kolkata').format('DD-MM-YYYY');
                                                               const createdAt = formatDiffrentDate(data?.createdAt);
                                                               const rowNumber = (PaginatedData?.pageNo - 1) * PaginatedData?.pageSize + (i + 1);
                                                               return (
                                                                  <tr key={data?._id}>


                                                                     <td className="text-start align-content-center ps-4">
                                                                        <span className="">
                                                                           {rowNumber}
                                                                        </span>

                                                                     </td>
                                                                     <td className="text-start align-content-center">
                                                                        {data?.Worker?.profile_pic ?
                                                                           <img src={data?.Worker?.profile_pic as string} alt="profile-pic" className="profile-pic" />
                                                                           :
                                                                           <span className="d-flex align-items-center ">
                                                                              <img src={profileIcon} alt="profileIcon" className="profile-pic" />
                                                                           </span>}
                                                                     </td>
                                                                     <td className="text-start align-content-center ps-4">
                                                                        <span className="">
                                                                           {data?.Worker?.name}
                                                                        </span>

                                                                     </td>
                                                                     <td className="text-start align-content-center ps-4">
                                                                        <span className="">
                                                                           {formatCategory(data?.Worker?.worker_type)}
                                                                        </span>

                                                                     </td>
                                                                     <td className="text-start align-content-center ps-4">
                                                                        <span className="">
                                                                           {data?.Worker?.phone}
                                                                        </span>

                                                                     </td>
                                                                     <td className="text-start align-content-center ps-4">
                                                                        <span className="">
                                                                           {!data?.is_lead_matured ? "NA" : data?.membership_type ? "Memberhsip" : data?.service_type ? "Subscription" : ""}
                                                                        </span>

                                                                     </td>
                                                                     <td className="text-start align-content-center ps-4">
                                                                        <span className="">
                                                                           {formatCategory(data?.subscription_type) ?? "NA"}
                                                                        </span>

                                                                     </td>

                                                                     <td className="text-start align-content-center ps-4">
                                                                        <span className="">
                                                                           {createdAt?.formattedDate}
                                                                        </span>

                                                                     </td>
                                                                     <td className="align-content-center ">
                                                                        <div className="d-flex justify-content-center gap-3 ">
                                                                           <Link to={`/workers/${data?.worker_id}`} onClick={() => {

                                                                              setHandlePageClick("workerDetails");

                                                                           }}>
                                                                              <button className="btn btn-sm delete_btn" >
                                                                                 <img src={eye} />
                                                                              </button>
                                                                           </Link>
                                                                        </div>
                                                                     </td>
                                                                  </tr>
                                                               )
                                                            }
                                                            )
                                                         }

                                                      </tbody>
                                                   </table>
                                                   {
                                                      loading ? <LoadingGif /> : ""
                                                   }
                                                </div>
                                                <Paginator
                                                   totalPages={PaginatedData?.totalPages}
                                                   pageNo={PaginatedData?.pageNo}
                                                   onPageChange={(e, no) => setPaginatedData({
                                                      ...PaginatedData,
                                                      pageNo: no

                                                   })}
                                                   alignment="right"
                                                />
                                             </div>

                                          </div>

                                       </div>
                                       :
                                       clickedSidePage?.ratings && selectedWorker?.worker_type !== ECategory?.SALES_PROFESSIONAL ?
                                          <div className="card">
                                             <div className="card-header d-flex justify-content-between" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                                                <h5 className="text-start mb-0" >
                                                   My Rating
                                                </h5>
                                                <div className="d-flex gap-2">
                                                   <h6>
                                                      Average Ratings:
                                                   </h6>
                                                   <strong className="d-flex align-items-center">
                                                      {averageRating}
                                                   </strong>
                                                </div>

                                             </div>
                                             <div className="card-body">
                                                <div className="border rounded p-3 pb-0 transaction-body" >
                                                   <div className="table-responsive">
                                                      <table className="table  card-body">
                                                         <thead>
                                                            <tr className="transaction-tr">
                                                               <th scope="col" className="text-start ps-4">Sr.No.</th>
                                                               <th scope="col" className="text-start ps-4">Ratings</th>
                                                               <th scope="col" className="text-start ps-4">Rating Type</th>
                                                               <th scope="col" className="text-start ps-4">Review</th>
                                                               <th scope="col" className="text-start ps-4">User Name</th>
                                                               <th scope="col" className="text-start ps-4">User Phone</th>
                                                               <th scope="col" className="text-start ps-4">Service Name</th>
                                                               {/* <th scope="col" className="text-start ps-4"></th> */}

                                                               <th scope="col" className="text-start ps-4">Published At</th>

                                                            </tr>

                                                         </thead>
                                                         <tbody>
                                                            {
                                                               ratingsArray && ratingsArray?.map((data, i) => {
                                                                  // const createdAt = moment(data?.createdAt).tz('Asia/Kolkata').format('DD-MM-YYYY');
                                                                  const createdAt = formatDiffrentDate(data?.createdAt);
                                                                  const rowNumber = (PaginatedData?.pageNo - 1) * PaginatedData?.pageSize + (i + 1);

                                                                  const dotData = data?.comment
                                                                     ?.slice(0, 40) + (data?.comment.length > 40 ? " ..." : "");

                                                                  return (
                                                                     <>
                                                                        <tr key={data?._id}>
                                                                           <td className="text-start align-content-center ps-4">
                                                                              <span className="">
                                                                                 {rowNumber}
                                                                              </span>

                                                                           </td>
                                                                           <td className="text-start align-content-center ps-4">
                                                                              <StarRating averageRating={data?.rating} />
                                                                           </td >
                                                                           <td className="text-start align-content-center ps-4">
                                                                              {data?.rating_type === "professionalServiceRatings" || data?.rating_type === "doorStepRatings" ? "Service Rating" : "Worker Rating"}
                                                                           </td >

                                                                           <td className="text-start align-content-center ps-4" title={data?.comment} style={{ cursor: "pointer" }}>
                                                                              {dotData}
                                                                           </td >

                                                                           <td className="text-start align-content-center ps-4" >

                                                                              {data?.user_name}
                                                                           </td>
                                                                           <td className="text-start align-content-center ps-4">
                                                                              {data?.user_phone}

                                                                           </td>

                                                                           <td className="text-start align-content-center ps-4 ">

                                                                              {data?.rating_type === "normal" ? "None" : data?.service_title}
                                                                           </td>

                                                                           <td className="icon-td align-content-center text-start ps-4" >
                                                                              {createdAt?.formattedDate}
                                                                           </td>
                                                                        </tr >

                                                                     </>


                                                                  )
                                                               }
                                                               )
                                                            }

                                                         </tbody>
                                                      </table>
                                                      {
                                                         loading ? <LoadingGif /> : ""
                                                      }
                                                   </div>
                                                   <Paginator
                                                      totalPages={PaginatedData?.totalPages}
                                                      pageNo={PaginatedData?.pageNo}
                                                      onPageChange={(e, no) => setPaginatedData({
                                                         ...PaginatedData,
                                                         pageNo: no

                                                      })}
                                                      alignment="right"
                                                   />
                                                </div>

                                             </div>

                                          </div> :
                                          <div className="card">
                                             <div className="card-header d-flex justify-content-between" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                                                <h5 className="text-start mb-0 " >
                                                   My Earnings
                                                </h5>
                                                <div className="d-flex justify-content-end mb-3 gap-4">
                                                   <div className='d-flex gap-2 align-items-center ' style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                                                      <span className='text-dark font-weight-bold'>Total Earnings:</span>
                                                      <span className='text-dark font-weight-bold'>&#8377; {totalData?.totalEarnings?.toFixed(2)}</span>
                                                   </div>
                                                   <div className="d-flex gap-2">
                                                      <span className="d-flex align-items-center pagesize-text" >
                                                         PageSize
                                                      </span>

                                                      <select
                                                         className="form-select"
                                                         style={{ backgroundPosition: "right 5px center", width: "60px" }}
                                                         aria-label="Default select example"
                                                         value={PaginatedData?.pageSize} // Bind the value to the state
                                                         onChange={handlePageSizeChange} // Handle the change
                                                      >
                                                         <option value={10}>10</option>
                                                         <option value={20}>20</option>
                                                         <option value={50}>50</option>
                                                         <option value={100}>100</option>
                                                         <option value={200}>200</option>
                                                      </select>
                                                      <ExportDocs headers={headersFOrEarnings} formattedData={formattedDataForEarnings} clickHandler={exportPdfForEarnings} />
                                                   </div>
                                                </div>

                                             </div>
                                             <div className="card-body">
                                                <div className="border rounded p-3 pb-0 transaction-body" >
                                                   <div className="table-responsive">
                                                      <table className="table  card-body">
                                                         <thead>

                                                            {
                                                               selectedWorker?.worker_type !== ECategory?.SALES_PROFESSIONAL ?
                                                                  <tr className="transaction-tr">
                                                                     <th scope="col" className="text-start ps-4">Sr.No.</th>
                                                                     <th scope="col" className="text-start ps-4">Service Name</th>
                                                                     <th scope="col" className="text-start ps-4">Service Count</th>
                                                                     <th scope="col" className="text-start ps-4">User Name</th>
                                                                     <th scope="col" className="text-start ps-4">Phone / Email</th>
                                                                     <th scope="col" className="text-start ps-4">Earnigs</th>
                                                                     <th scope="col" className="text-start ps-4">Worked At</th>
                                                                  </tr> :
                                                                  <tr className="transaction-tr">
                                                                     <th scope="col" className="text-start ps-4">Sr.No.</th>
                                                                     <th scope="col" className="text-start ps-4">Worker ID</th>
                                                                     <th scope="col" className="text-start ps-4">Earnings Type</th>
                                                                     <th scope="col" className="text-start ps-4">Worker Name</th>
                                                                     <th scope="col" className="text-start ps-4">Worker Phone</th>
                                                                     <th scope="col" className="text-start ps-4">Commision</th>
                                                                     <th scope="col" className="text-start ps-4">Lead Matured</th>
                                                                     <th scope="col" className="text-start ps-4">CreatedAt</th>
                                                                  </tr>
                                                            }

                                                            {/* <th scope="col" className="col-lg-2 ps-4 ">Action</th> */}

                                                         </thead>
                                                         <tbody>
                                                            {
                                                               earningsArray && earningsArray?.map((data, i) => {
                                                                  // const createdAt = moment(data?.createdAt).tz('Asia/Kolkata').format('DD-MM-YYYY');
                                                                  const createdAt = formatDiffrentDate(data?.createdAt);
                                                                  const rowNumber = (PaginatedData?.pageNo - 1) * PaginatedData?.pageSize + (i + 1);

                                                                  return (
                                                                     <>
                                                                        {
                                                                           selectedWorker?.worker_type !== ECategory?.SALES_PROFESSIONAL ?
                                                                              <tr key={data?._id}>
                                                                                 <td className="text-start align-content-center ps-4">
                                                                                    <span className="">
                                                                                       {rowNumber}
                                                                                    </span>

                                                                                 </td>
                                                                                 <td className="text-start align-content-center ps-4">
                                                                                    <span className="">
                                                                                       {data?.service_title}
                                                                                    </span>

                                                                                 </td>
                                                                                 <td className="text-start align-content-center ps-4">
                                                                                    <span className="">
                                                                                       {data?.service_count}
                                                                                    </span>

                                                                                 </td>
                                                                                 <td className="text-start align-content-center ps-4">
                                                                                    <span className="">
                                                                                       {data?.User?.name}
                                                                                    </span>

                                                                                 </td>
                                                                                 <td className="text-start align-content-center ps-4">
                                                                                    <span className="">
                                                                                       {data?.User?.phone || data?.User?.email}
                                                                                    </span>

                                                                                 </td>
                                                                                 <td className="text-start align-content-center ps-4">
                                                                                    <span className="">
                                                                                       &#8377; {data?.worker_commision}
                                                                                    </span>

                                                                                 </td>

                                                                                 <td className="icon-td align-content-center text-start ps-4">
                                                                                    {createdAt?.formattedDate}
                                                                                 </td>
                                                                              </tr>
                                                                              :
                                                                              <tr key={data?._id}>
                                                                                 <td className="text-start align-content-center ps-4">
                                                                                    <span className="">
                                                                                       {rowNumber}
                                                                                    </span>

                                                                                 </td>
                                                                                 <td className="text-start align-content-center ps-4">
                                                                                    <span className="">
                                                                                       {data?.worker_id}
                                                                                    </span>

                                                                                 </td>
                                                                                 <td className="text-start align-content-center ps-4">
                                                                                    <span className="">
                                                                                       {!data?.is_lead_matured ? "NA" : data?.membership_type ? "Memberhsip" : data?.service_type ? "Subscription" : ""}
                                                                                    </span>

                                                                                 </td>
                                                                                 <td className="text-start align-content-center ps-4">
                                                                                    <span className="">
                                                                                       {data?.Worker?.name ?? "NA"}
                                                                                    </span>

                                                                                 </td>
                                                                                 <td className="text-start align-content-center ps-4">
                                                                                    <span className="">
                                                                                       {data?.Worker?.phone ?? "NA"}
                                                                                    </span>

                                                                                 </td>
                                                                                 <td className="text-start align-content-center ps-4">
                                                                                    <span className="">
                                                                                       &#8377; {data?.commision}
                                                                                    </span>

                                                                                 </td>

                                                                                 <td className="text-start align-content-center ps-4 ">
                                                                                    <span className=" align-items-center">
                                                                                       {data?.is_lead_matured ? "Yes" : "No"}
                                                                                    </span> </td>

                                                                                 <td className="icon-td align-content-center text-start ps-4">
                                                                                    {createdAt?.formattedDate}
                                                                                 </td>
                                                                              </tr>
                                                                        }
                                                                     </>


                                                                  )
                                                               }
                                                               )
                                                            }

                                                         </tbody>
                                                      </table>
                                                      {
                                                         loading ? <LoadingGif /> : ""
                                                      }
                                                   </div>
                                                   <Paginator
                                                      totalPages={PaginatedData?.totalPages}
                                                      pageNo={PaginatedData?.pageNo}
                                                      onPageChange={(e, no) => setPaginatedData({
                                                         ...PaginatedData,
                                                         pageNo: no

                                                      })}
                                                      alignment="right"
                                                   />
                                                </div>

                                             </div>

                                          </div>

                           }

                        </div>
                     </div>
                  </div>

               </div>
            </div>
         </div>
      </MainLayout>
   )
}

export default WorkerDetailsPage;